<template>
    <div>

        <!-- Mode -->
        <p>
            Mode
            <b-select v-model="mode" :options="[
                { text: 'Template (page unique)',  value: 'template'           },
                { text: 'Template multi pages',    value: 'template multi page' }
            ]" />
        </p>

        <!-- ── Page unique ──────────────────────────────────────── -->
        <div v-if="mode === 'template'">

            <p><strong>Template html</strong></p>
            <ace_editor
                ref="single_editor"
                mode="html"
                :code="html_single"
                :height="300"
                @update="html_single = $event"
            />

            <p class="mt-3">
                Extension de sortie
                <b-input v-model="extension" placeholder="pdf" />
            </p>
            <p>
                Nom des fichiers
                <b-input v-model="name" placeholder="nom" />
            </p>
            <p>
                Colonne de récupération du fichier
                <b-input v-model="column" placeholder="colonne" />
            </p>
            <p>
                <b-checkbox v-model="url">Récupérer sous forme d'url</b-checkbox>
            </p>
            <p>
                <b-checkbox v-model="lodash_template">Template lodash ${ }</b-checkbox>
            </p>
            <p>
                <b-checkbox v-model="handlebars_template">Template handlebars {{ }}</b-checkbox>
            </p>

        </div>

        <!-- ── Multi pages ──────────────────────────────────────── -->
        <div v-else>

            <div v-for="(page, idx) in html_pages" :key="page.id" class="mb-4">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <strong>Page {{ idx + 1 }}</strong>
                    <b-button size="sm" variant="outline-danger" @click="removePage(idx)">
                        <i class="fas fa-times" /> Supprimer
                    </b-button>
                </div>
                <ace_editor
                    :ref="'page_editor_' + page.id"
                    mode="html"
                    :code="page.content"
                    :height="300"
                    @update="updatePage(idx, $event)"
                />
            </div>

            <b-button variant="outline-success" class="mb-3" @click="addPage">
                <i class="fas fa-plus mr-1" /> Ajouter une page
            </b-button>

            <p>
                Nom des fichiers
                <b-input v-model="name" placeholder="nom" />
            </p>
            <p>
                Colonne de récupération de l'url du fichier
                <b-input v-model="column" placeholder="colonne" />
            </p>
            <p>
                <b-checkbox v-model="lodash_template">Template lodash ${ }</b-checkbox>
            </p>
            <p>
                <b-checkbox v-model="handlebars_template">Template handlebars {{ }}</b-checkbox>
            </p>

        </div>

    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
    import ace_editor from "../ace_editor.vue";

    export default {
        name: "html_step",

        components: { ace_editor },

        props: {
            data:          { default: () => [] },
            files:         { default: () => [] },
            client:        { default: null },
            step_position: { default: 0 }
        },

        data() {
            return {
                mode:                "template",
                html_single:         "",
                html_pages:          [{ id: uniqueId("p"), content: "" }],
                extension:           "",
                name:                "",
                column:              "",
                url:                 false,
                lodash_template:     true,
                handlebars_template: true,
            };
        },

        methods: {
            updatePage(idx, val) {
                this.html_pages[idx].content = val;
            },

            addPage() {
                this.html_pages.push({ id: uniqueId("p"), content: "" });
            },

            removePage(idx) {
                if (this.html_pages.length > 1)
                    this.html_pages.splice(idx, 1);
            },

            save() {
                if (this.mode === "template") {
                    return {
                        type:                "template",
                        html:                this.html_single,
                        extension:           this.extension,
                        name:                this.name,
                        column:              this.column,
                        url:                 this.url,
                        lodash_template:     this.lodash_template,
                        handlebars_template: this.handlebars_template,
                    };
                } else {
                    return {
                        type:                "template multi page",
                        html:                this.html_pages.map(p => p.content),
                        extension:           "pdf",
                        name:                this.name,
                        column:              this.column,
                        lodash_template:     this.lodash_template,
                        handlebars_template: this.handlebars_template,
                    };
                }
            },

            load(data) {
                if (!data) return;
                this.mode = data.type === "template multi page" ? "template multi page" : "template";

                if (this.mode === "template") {
                    this.html_single = data.html || "";
                    this.extension   = data.extension || "";
                    this.url         = data.url || false;
                } else {
                    var pages = Array.isArray(data.html) ? data.html : [""];
                    this.html_pages = pages.map(p => ({ id: uniqueId("p"), content: p }));
                }

                this.name                = data.name                !== undefined ? data.name                : "";
                this.column              = data.column              !== undefined ? data.column              : "";
                this.lodash_template     = data.lodash_template     !== undefined ? data.lodash_template     : true;
                this.handlebars_template = data.handlebars_template !== undefined ? data.handlebars_template : true;
            },

            get_data() {
                return this.save();
            },
        },

        mounted() {}
    };
</script>

<style scoped>
</style>
